import { app } from '../../../bootstrap/core';

import { paymentPartnersComponent } from './paymentPartners.component';
import paymentPartnersTemplate from './paymentPartners.html';
import paymentPartnersSuggestTemplate from './paymentPartnersSuggest.tpl.html';

import ignorePaymentPartnerList from './templates/ignorePaymentPartnerList.html';
import standingOrdersBlacklistTemplate from './templates/standingOrdersBlacklist.html';
import depositsBlacklistTemplate from './templates/depositsBlacklist.html';
import debitsBlacklistTemplate from './templates/debitsBlacklist.html';
import debitsAndDepositsBlacklistTemplate from './templates/debitsAndDepositsBlacklist.html';
import refuseDebitsAndDepositsPartnerBlacklistTemplate from './templates/refuseDebitsAndDepositsPartnerBlacklist.html';
import refuseStandingOrdersBlacklistTemplate from './templates/refuseStandingOrdersBlacklist.html';
import acceptDepositsCertainBlackOrWhiteListIncludeTemplate from './templates/acceptDepositsCertainBlackOrWhiteListInclude.html';
import acceptDebitsCertainBlackOrWhiteListIncludeTemplate from './templates/acceptDebitsCertainBlackOrWhiteList.html';
import acceptDebitsCertainSpecialPaymentPartnerListTemplate from './templates/acceptDebitsCertainSpecialPaymentPartnerList.html';
import acceptStandingOrdersCertainBlackOrWhiteListIncludeTemplate from './templates/acceptStandingOrdersCertainBlackOrWhiteList.html';
import acceptStandingOrdersCertainSpecialPaymentPartnerListTemplate from './templates/acceptStandingOrdersCertainSpecialPaymentPartnerList.html';

app.component(paymentPartnersComponent.name, paymentPartnersComponent);
app.constant('PaymentPartnersSuggestTemplate', paymentPartnersSuggestTemplate);

app.run(($templateCache) => {
  $templateCache.put('paymentPartnersBlacklist', paymentPartnersTemplate);
  $templateCache.put('ignorePaymentPartnerList', ignorePaymentPartnerList);

  $templateCache.put('StandingOrdersBlacklist', standingOrdersBlacklistTemplate);
  $templateCache.put('DepositsPartnerBlacklist', depositsBlacklistTemplate);
  $templateCache.put('DebitsPartnerBlacklist', debitsBlacklistTemplate);
  $templateCache.put('DebitsAndDepositsPartnerBlacklist', debitsAndDepositsBlacklistTemplate);

  $templateCache.put('refuseDebitsAndDepositsPartnerBlacklist', refuseDebitsAndDepositsPartnerBlacklistTemplate);
  $templateCache.put('refuseStandingOrdersBlacklist', refuseStandingOrdersBlacklistTemplate);
  $templateCache.put('acceptDepositsCertainBlackOrWhiteListInclude', acceptDepositsCertainBlackOrWhiteListIncludeTemplate);
  $templateCache.put('acceptDebitsCertainBlackOrWhiteListInclude', acceptDebitsCertainBlackOrWhiteListIncludeTemplate);
  $templateCache.put('acceptDebitsCertainSpecialPaymentPartnerList', acceptDebitsCertainSpecialPaymentPartnerListTemplate);
  $templateCache.put('acceptStandingOrdersCertainBlackOrWhiteListInclude', acceptStandingOrdersCertainBlackOrWhiteListIncludeTemplate);
  $templateCache.put('acceptStandingOrdersCertainSpecialPaymentPartnerList', acceptStandingOrdersCertainSpecialPaymentPartnerListTemplate);
});
